import { camelcaseKeys } from 'src/utils/camelize-keys';
import { decamelizeKeys } from 'src/utils/decamelize-keys';

import { PlatformHierarchyNode, PlatformNode } from './_types';

/**
 * Normalizes platform node data from API to client format
 */
export function normalizePlatformNode(node: any): PlatformNode {
  return camelcaseKeys(node, { deep: true }) as PlatformNode;
}

/**
 * Normalizes platform hierarchy node data from API to client format
 */
export function normalizePlatformHierarchyNode(
  node: any
): PlatformHierarchyNode {
  return camelcaseKeys(node, { deep: true }) as PlatformHierarchyNode;
}

/**
 * Denormalizes platform node data from client to API format
 */
export function denormalizePlatformNode(node: Partial<PlatformNode>): any {
  return decamelizeKeys(node, { deep: true });
}

/**
 * Denormalizes platform hierarchy node data from client to API format
 */
export function denormalizePlatformHierarchyNode(
  node: Partial<PlatformHierarchyNode>
): any {
  return decamelizeKeys(node, { deep: true });
}
